import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface CallCompletionPromptProps {
  open: boolean;
  patientName: string;
  onComplete: () => void;
  onDismiss: () => void;
}

/**
 * Dialog that appears when provider returns to MedArrive window during an active call
 *
 * Asks the provider if the telehealth call is complete, allowing them to:
 * - Click "Yes, Complete Call" to mark the visit as complete and stop the timer
 * - Click "No, Still in Call" to dismiss the dialog and continue the call
 */
export default function CallCompletionPrompt({
  open,
  patientName,
  onComplete,
  onDismiss,
}: CallCompletionPromptProps) {
  return (
    <Dialog open={open} onClose={onDismiss} maxWidth="sm" fullWidth>
      <DialogTitle>Complete Virtual Visit</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Is the telehealth call with <strong>{patientName}</strong> complete?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="inherit">
          No, Still in Call
        </Button>
        <Button
          onClick={onComplete}
          color="primary"
          variant="contained"
          autoFocus
        >
          Yes, Complete Call
        </Button>
      </DialogActions>
    </Dialog>
  );
}
